var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLeftLil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "80px",
    viewBox: "0 0 89 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-All-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COM/Error-404_1300",
    transform: "translate(-831.000000, -512.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "animated-scene",
    transform: "translate(726.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-1",
    transform: "translate(105.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#284086",
    points: "80.1 0 80.1 80 60.075 60 40.05 80 20.025 60 0 80 0 0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 13.35,
    y: 13.3333333,
    width: 32.6333333,
    height: 14.8148148
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,14.8148148 L44.5,26.6666667 L14.8333333,26.6666667 L14.8333333,14.8148148 L44.5,14.8148148 M47.4666667,11.8518519 L11.8666667,11.8518519 L11.8666667,29.6296296 L47.4666667,29.6296296 L47.4666667,11.8518519 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 35.6,
    y: 17.7777778,
    width: 8.9,
    height: 8.88888889
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 54.8833333,
    y: 13.3333333,
    width: 32.6333333,
    height: 14.8148148
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0333333,14.8148148 L86.0333333,26.6666667 L56.3666667,26.6666667 L56.3666667,14.8148148 L86.0333333,14.8148148 M89,11.8518519 L53.4,11.8518519 L53.4,29.6296296 L89,29.6296296 L89,11.8518519 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 77.1333333,
    y: 17.7777778,
    width: 8.9,
    height: 8.88888889
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 29.6666667,
    y: 44.4444444,
    width: 32.6333333,
    height: 8.88888889
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLeftLil);
export default __webpack_public_path__ + "static/media/error_left_lil.84248879ea549d366884debcb4091cb6.svg";
export { ForwardRef as ReactComponent };